import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXCloud = () => (
  <ArticleWrapper articleId="hmx_cloud">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>HMX Cloud</h1>
        {/* Add your HMX Cloud article content here */}
        <p>This is a placeholder article for the HMX Cloud switch. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default HMXCloud;
